import ClassHelper from '../ClassHelper';
import DateTZ from '../date/DateTZ';
import Image from '../file/Image';

class Profile extends ClassHelper {
  constructor({ firstName, lastName, middleName = '', fullName, avatar, nickname, birthday, approved = false } = {}) {
    super(...arguments);
    this.firstName = firstName || '';
    this.lastName = lastName || '';
    this.middleName = middleName || '';
    this.fullName = fullName || `${this.firstName} ${this.lastName} ${this.middleName}`.trim();
    this.avatar = this.obj({ path: avatar }, Image);
    this.nickname = nickname;
    this.birthday = this.obj(birthday, DateTZ);
    this.approved = approved;
  }

  getAvatar(size) {
    return this.avatar ? this.avatar.getUrl(size) : '';
  }
}

export default Profile;